import { Component } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Button } from "@ankaadia/ankaadia-shared-frontend";
import { FieldsetModule } from "primeng-v17/fieldset";
import { InputTextModule } from "primeng-v17/inputtext";
import { MessageModule } from "primeng-v17/message";
import { TranslateDirective } from "../../../shared/transloco/translate.directive";
import { NewUiTranslationProposalGatheringComponent } from "./new-ui-translationProposalGathering.component";

@Component({
  selector: "app-translation-proposal-gathering",
  templateUrl: "./translationProposalGathering.component.html",
  styleUrl: "./translationProposalGathering.component.scss",
  imports: [TranslateDirective, MessageModule, FieldsetModule, FormsModule, InputTextModule, Button],
})
export class TranslationProposalGatheringComponent extends NewUiTranslationProposalGatheringComponent {}
